import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ReportTemplateService from '../../../Services/ReportTemplateService';

const parameterTypeSelectValues = [
  { label: 'Choose one...', value: '', disabled: true },
  { label: 'Required', value: '1', disabled: false },
  { label: 'Optional', value: '2', disabled: false },
  { label: 'Disabled', value: '3', disabled: false },
];

// Never actually instantiated: the host (DashboardAdmin) always passes an
// editedItem (the selected report), so GeneralEditWizzardBase never falls
// back to `new windowDescription.itemType()`. Placeholder to satisfy the
// wizard's constructor contract.
class EditTemplateItemPlaceholder {}

export default class EditTemplateWindowDescription {
  static titleForEdit = (item) => `Edit Template '${item.Name}'`;
  static finishButtonLabel = 'Update';
  static messageOnSuccess = 'Report template has been updated.';
  static itemType = EditTemplateItemPlaceholder;

  // Preserves the old EditTemplatePopUpPanel.onSubmit FormData shape exactly,
  // including appending selectedFile even when null (the backend already
  // tolerates it) and dropping the 'Code' suffix on the appended keys while
  // the item fields keep it. MUST return the promise (wizard contract).
  static serviceFunction = (edited) => {
    const data = new FormData();
    data.append('ReportTemplateId', edited.ReportTemplateId);
    data.append('file', edited.selectedFile);
    data.append('Name', edited.Name);
    data.append('OfficeParameterType', edited.OfficeParameterTypeCode);
    data.append('ClientParameterType', edited.ClientParameterTypeCode);
    data.append('ProjectParameterType', edited.ProjectParameterTypeCode);
    return ReportTemplateService.EditReportTemplateFileAsync(data);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'Report Template',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'selectedFile',
          label: 'Update XLS or XLSX file (Optional)',
          className: 'col-6',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: '.xls, .xlsx',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OfficeParameterTypeCode',
          label: 'Office Parameter Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: parameterTypeSelectValues,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ClientParameterTypeCode',
          label: 'Client Parameter Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: parameterTypeSelectValues,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ProjectParameterTypeCode',
          label: 'Project Parameter Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: parameterTypeSelectValues,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
